import { CheckCircleIcon } from "@heroicons/react/outline";
import { Card } from "components/Card";
import { Header } from "domain/online-appointments/components/Header";

import { Loading } from "domain/online-appointments/components/Loading";
import { Wrapper } from "domain/online-appointments/components/Wrapper";
import { Suspense, useState } from "react";
import { useTranslation } from "react-i18next";
import { Details } from "./Details";

export const Container = () => {
  const [paid, setPaid] = useState(false);

  const { t } = useTranslation();

  if (paid) {
    return (
      <Wrapper>
        <div className="w-full max-w-lg">
          <Card>
            <div className="text-center">
              <CheckCircleIcon className="w-10 mx-auto text-green-500" />
              <Header
                title={t("Successfully paid")}
                description={t("Thank you for your appointment!")}
              />
            </div>
          </Card>
        </div>
      </Wrapper>
    );
  }

  return (
    <Suspense fallback={<Loading />}>
      <Details onPaymentSuccess={() => setPaid(true)} />
    </Suspense>
  );
};
